declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, GetSpermSourceDetailsRequest, GenericProcPostRequest, S_Methods, IvfExtraDataController } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbSemanEditModal } from './semanedit.modal';

@Component({
  selector: 'spermcollection2',
  templateUrl: './spermcollection2.component.html',
  styleUrls: ['./spermcollection2.component.scss'],
  animations: [routerTransition()]
})

export class SpermCollection2Component implements OnInit {
    @Output() GoFollicle: EventEmitter<any> = new EventEmitter();
  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    @Input() GradingModel: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  //

    CurrentSpermSourceDetailsController: SpermSourceDetailsController[];
    SpermEndInfo: SpermSourceDetailsController;
    CurrentSpermSourceDetailsRequest: SpermSourceDetailsRequest;
    LoadSperm() {
        this.CurrentSpermSourceDetailsRequest = new SpermSourceDetailsRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentSpermSourceDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        this.CurrentSpermSourceDetailsRequest.ConditionalOperator = 10;
        this.CurrentSpermSourceDetailsRequest.FromDate = new Date();
        this.CurrentSpermSourceDetailsRequest.ToDate = new Date();
        this.CurrentSpermSourceDetailsRequest.CycleCode = this.CycleCode;
        this.CurrentSpermSourceDetailsRequest.SemanDataCode = 0;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentSpermSourceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetSpermSourceDetailsController();
    }

    GetSpermSourceDetailsController() {
        this.StartRefreshing();


        this.actorservice.GetSpermSourceDetailsController(this.CurrentSpermSourceDetailsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSpermSourceDetailsController = this.ApiResData.Result;
                    this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
                   
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadPatients();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  CurrentSemanAnalysisController: IvfExtraDataController[];
  SpermInfo: IvfExtraDataController;
  Viability: IvfExtraDataController;
  LoadSA() {
    var getReq = new GetSpermSourceDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101044;
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.CycleCode = this.CycleCode;
    getReq.SemanDataCode = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101044;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentSemanAnalysisController = JSON.parse(data);
          if (this.CurrentSemanAnalysisController.length == 1 && this.CurrentSemanAnalysisController[0].DataContext == 'NA') {
            this.SpermInfo = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];
            this.Viability = new IvfExtraDataController();//this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability'); //[0];
            this.SpermInfo.DataContext = 'SlugishMotile';
            this.Viability.DataContext = 'Viability';
            this.SpermInfo.CycleCode = this.CycleCode;
            this.Viability.CycleCode = this.CycleCode;
            this.SpermInfo.DataType = 'string';
            this.Viability.DataType = 'string';

          }
          else {
            if (this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile') != null)
              this.SpermInfo = this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile');
            else {
              this.SpermInfo = new IvfExtraDataController();// this.CurrentSemanAnalysisController.find(x => x.DataContext == 'SlugishMotile'); //[0];

              this.SpermInfo.DataContext = 'SlugishMotile';

              this.SpermInfo.CycleCode = this.CycleCode;

              this.SpermInfo.DataType = 'string';

            }
            if (this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability') != null)
              this.Viability = this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability');
            else {
              this.Viability = new IvfExtraDataController();//this.CurrentSemanAnalysisController.find(x => x.DataContext == 'Viability'); //[0];

              this.Viability.DataContext = 'Viability';

              this.Viability.CycleCode = this.CycleCode;

              this.Viability.DataType = 'string';
            }
          }
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    //alert("pickup");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          //this.ReceipientActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadStoragedata();
          //this.LoadMasterReq();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfSpermStoreByCodeController: IvfSpermStoreByCodeController[];
  SpermSourceInfo: IvfSpermStoreByCodeController;
  CurrentIvfSpermStoreByCodeRequest: IvfSpermStoreByCodeRequest;
  LoadStoragedata() {
    this.CurrentIvfSpermStoreByCodeRequest = new IvfSpermStoreByCodeRequest();
    this.CurrentIvfSpermStoreByCodeRequest.TreatmentCycle = this.SelectedTreatmentCycle.Code;
    this.CurrentIvfSpermStoreByCodeRequest.ActorCode = this.SelectedTreatmentCycle.EggActorCode;
    this.CurrentIvfSpermStoreByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetIvfSpermStoreByCodeController();
  }

  GetIvfSpermStoreByCodeController() {
    this.StartRefreshing();


    this.actorservice.GetIvfSpermStoreByCodeController(this.CurrentIvfSpermStoreByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfSpermStoreByCodeController = this.ApiResData.Result;
          if (this.CurrentIvfSpermStoreByCodeController
            != null &&
            this.CurrentIvfSpermStoreByCodeController.length == 1) {
            this.SpermSourceInfo = this.CurrentIvfSpermStoreByCodeController[0];
          }
          else {
            this.SpermSourceInfo = new IvfSpermStoreByCodeController();
            this.SpermSourceInfo.StorageUnitDetails = "";
            this.SpermSourceInfo.StorageUnitType = "";
            this.SpermSourceInfo.Volume = 0;
            this.SpermSourceInfo.VolumeUnits = "";
            this.SpermSourceInfo.SpermStoreCode = 0;





          }

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

 
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
   
    this.LoadSperm();
    this.LoadSA();
      this.LoadCycles();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    SemanAnalysis: TreatmentCycleStatusController[];
    SemanAnalysis2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        //this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.SemanAnalysis = this.ApiResData.Result;
                    var Semanlist = this.SemanAnalysis.filter(
                        function (a) {
                            return a.PhaseActivity == "Semen Analysis";
                        });
                    this.SemanAnalysis = Semanlist;
                    this.SemanAnalysis2 = this.SemanAnalysis[0];
                   // alert(this.SemanAnalysis2.ActivityStatus);
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  

  

 
  
  //
 
  //

    Editseman() {
        const modalRef = this.modalService.open(NgbSemanEditModal,
            {
              centered: true,
              size: "lg",
                keyboard: false,
                backdrop: 'static'

            })

        modalRef.componentInstance.CycleCode = this.CycleCode; /*this.GetCycleCode(s.FollicularGrowth)[0].TreatmentCycle*/
        //modalRef.componentInstance.FollicularGrowthCode = s.FollicularGrowth;
        //modalRef.componentInstance.ActivityCode = s.CycleActivity;
        modalRef.componentInstance.PatientCode = this.SelectedTreatmentCycle.EggPatientRegistrationNo;
        modalRef.componentInstance.Eggsourcetype = this.SelectedTreatmentCycle.EggSourceType;
        modalRef.componentInstance.ActorCode = this.ActorCode;
        //modalRef.componentInstance.OocyteQualityCode = this.OqaDetailsData.OocyteQualityCode;
        //modalRef.componentInstance.DOC = s.DOC;
        modalRef.componentInstance.GradingModel = this.GradingModel;
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadSperm();
                this.LoadCycles();
                this.GoFollicle.emit();
            }

        });
    }
 



  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  printsource() {
    this.printService.printDocument("spermsourcedetails",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, TotalOocytes: this.SpermEndInfo.TotalOocytes, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, MotileSpermMotility: this.SpermEndInfo.MotileSpermMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,
      }
    );
  }

  printsourcedroplet() {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("spermsourcedetailsdroplet",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, TotalOocytes: this.SpermEndInfo.TotalOocytes, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, TotalMotility: this.SpermEndInfo.ActiveProgressiveMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        ProgressiveMotility: this.SpermEndInfo.ProgressiveMotility, Morphology: this.SpermEndInfo.Morphology, NonProgressiveMotility: this.SpermEndInfo.NonProgressiveMotility, DFI: this.SpermEndInfo.DFI,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,

      }
    );
  }

}
